export type TProductType =
  | 'pass'
  | 'sessionpass'
  | 'addon'
  | 'giftcard'
  | 'wallet'
  | 'package'
  | 'custom'
  | 'membership'
  | 'partypackage'
  | 'recurringpass'
  | 'cashlesscard';

/** Types that ALWAYS have sessions */
export const CSessionBasedProductTypes: TProductType[] = ['sessionpass', 'partypackage', 'recurringpass'];

/** Types that ALWAYS require a purchase date */
export const CDateBasedProductTypes: TProductType[] = ['sessionpass', 'partypackage', 'recurringpass', 'package'];
export const CCannotBeAddedToExistingBooking: TProductType[] = ['giftcard', 'membership'];
export const COpenProducts = 'CHECKOUT.OPEN_PRODUCTS';
export const CAllowedUserDefinedValues: TProductType[] = ['giftcard', 'wallet'];
